import React from 'react';

type TProps = {
  active: boolean;
  children: JSX.Element;
};

export function LiferayTest({ children, active }: TProps) {
  return active ? (
    <div className="smls-lf" data-testid="liferay-test">
      {children}
    </div>
  ) : (
    <>{children}</>
  );
}
